








































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from "@/enums/ProposalState";
import { ProjectState } from "../../enums/projectState";
import Porposal from "@/models/porposal/porposal.model";
import ProposalDisbursement from "@/models/porposal/proposalDisbursement.model";
import PorposalService from "../../services/porposal.service";
import searcherService from "@/services/searcher.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import fileService from "@/services/file.service";
import { bus } from "@/main";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import ProposalCancelled from "../../models/porposal/proposalCancelled.model";

@Component({
  components: {
    DatePickerComponent,
    ResearchCenterBasicInformationComponent
  }
})
export default class ProjectByAnnoucementTableComponent extends GenericBTable<
  Porposal
> {
  @Prop() public estado!: ProjectState;
  proposalService: PorposalService = new PorposalService();
  annoucementId = null;
  isFondocyt = false;
  codes = "";
  code = "";
  ProjectState = ProjectState;
  file = null;
  file2 = null;
  loading = false;
  activeCancelled = false;
  showChangeStatus = false;
  currentProposal = new Porposal();
  model = new ProposalDisbursement();
  modelCancelled = new ProposalCancelled();

  created() {
    this.permissionValue = PermissionValue.PROYECTOPORCONVOCATORIA;
    this.tableConfig.controller = `Porposal/GetByProjectState/${this.estado}`;
    this.formatColumns();
  }

  mounted() {
    bus.$on("refresh_project", payLoad => {
      this.tableConfig.reload();
    });
  }
  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = `annoucementId eq  ${this.annoucementId}`;
    this.tableConfig.reload();
  }
  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Code, '${this.code}')`;
    this.tableConfig.reload();
  }
  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.project", true);
    let descriptionCanceled = new BTableColumn(
      "cancelationDescription",
      "table.cancelationDescription",
      true
    );
    descriptionCanceled.customTemplate = true;
    name.customTemplate = true;

    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.researchCenter",
      true
    );
    researchCenter.width = "350";
    name.width = "300";
    researchCenter.customTemplate = true;

    this.tableConfig.insertColumns(name, researchCenter);

    if (this.estado == this.ProjectState.cancelled) {
      let descriptionCancelled = new BTableColumn(
        "cancelationDescription",
        "table.cancelationDescription",
        true
      );
      this.tableConfig.insertColumns(descriptionCancelled);
    }

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }
  public executeProject(row: Porposal) {
    this.showChangeStatus = true;
    this.currentProposal = row;
  }
  public cancelExecuteProject() {
    if (this.activeCancelled) {
      this.activeCancelled = false;
    }
    this.showChangeStatus = false;
  }
  public onModalClose() {
    this.model.init();
    this.file = null;
    this.file2 = null;
  }
  public verOpciones(row: Porposal) {
    this.$router.push(`/convocatoria/propuesta/${row.id}/detail`);
  }

  async save() {
    if (!this.file) {
      this.operationFailed(
        "Favor subir un archivo de constancia de este desembolso!",
        5000
      );
    } else if (!this.file2) {
      this.operationFailed(
        "Favor subir un archivo de constancia de este desembolso!",
        5000
      );
    } else {
      try {
        var result = await this.$validator.validateAll();
        if (result) {
          this.$buefy.dialog.confirm({
            title: "Advertencia",
            type: "is-warning",
            size: "is-medium",
            hasIcon: true,
            confirmText: "Sí",
            cancelText: "No",
            message:
              "¿Seguro que desea ejecutar este proyecto?, de ser asi esta propuesta aparecerá en proyectos en ejecución.",
            onConfirm: () => this.onConfirmSave()
          });
        } else {
          throw this.$validator.errors.items.map(e => e.msg);
        }
      } catch (errors) {
        this.operationFailedErrors(errors);
      }
    }
  }

  async saveCancelledProject() {
    if (!this.modelCancelled.isCancelled) {
      this.operationFailed(
        "Debes estar seguro si deseas Cancelar este proyecto",
        5000
      );
      return;
    }
    if (!this.file) {
      this.operationFailed(
        "Favor subir un archivo de constancia de este cambio!",
        5000
      );
    } else {
      try {
        var result = await this.$validator.validateAll();
        if (result) {
          this.$buefy.dialog.confirm({
            title: "Advertencia",
            type: "is-warning",
            size: "is-medium",
            hasIcon: true,
            confirmText: "Sí",
            cancelText: "No",
            message:
              "¿Seguro que deseas cancelar este proyecto?, de ser asi esta propuesta aparecerá en proyectos cancelados.",
            onConfirm: () => this.onConfirmSaveCaselled()
          });
        } else {
          throw this.$validator.errors.items.map(e => e.msg);
        }
      } catch (errors) {
        this.operationFailedErrors(errors);
      }
    }
  }

  async onConfirmSave() {
    this.loading = true;
    let doc = await fileService.upload(this.file as File);

    doc.refEntityKey = "Id";
    doc.refEntityName = "Proposal";
    doc.refEntityValue = this.currentProposal.id as any;

    let doc2 = await fileService.upload(this.file2 as File);

    doc2.refEntityKey = "Id";
    doc2.refEntityName = "Proposal";
    doc2.refEntityValue = this.currentProposal.id as any;

    this.model.document = doc;
    this.model.documentContrat = doc2;

    this.proposalService
      .executeProject(this.currentProposal.id, this.model)
      .then(() => {
        this.cancelExecuteProject();
        this.operationSuccess();
        this.tableConfig.reload();
        bus.$emit("refresh_project", true);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  async onConfirmSaveCaselled() {
    this.loading = true;
    let doc = await fileService.upload(this.file as File);

    doc.refEntityKey = "Id";
    doc.refEntityName = "Proposal";
    doc.refEntityValue = this.currentProposal.id as any;

    this.modelCancelled.document = doc;

    this.proposalService
      .cancelledProject(this.currentProposal.id, this.modelCancelled)
      .then(() => {
        this.cancelExecuteProject();
        this.operationSuccess();
        this.tableConfig.reload();
        bus.$emit("refresh_project", true);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get totalProyecto() {
    var total = {
      FONDOCYT: 0,
      TotalGeneral: 0
    };
    for (let i = 0; i < this.currentProposal.porposalBudgetItems.length; i++) {
      const item = this.currentProposal.porposalBudgetItems[i];
      for (let y = 0; y < item.porposalBudgetSubItems.length; y++) {
        const subItem = item.porposalBudgetSubItems[y];
        for (
          let z = 0;
          z < subItem.porposalBudgetSubItemInstitutionDetails.length;
          z++
        ) {
          const detail = subItem.porposalBudgetSubItemInstitutionDetails[z];
          total.TotalGeneral += detail.amount;
          if (detail.isFondocyt) {
            total.FONDOCYT += detail.amount;
          }
        }
      }
    }

    return total;
  }

  cancelledProject(row: Porposal) {
    this.activeCancelled = true;
    this.currentProposal = row;
  }
 
  async verDocumento(row: Porposal) {
    if (row.documentContratId) {
      let contractDocument = await fileService.getDocumentById(row.documentContratId);
      
      if (contractDocument.contentType == "application/octet-stream") 
      {
        await fileService.downloadOctetFile(
          contractDocument.id,
          contractDocument.originalName
        );
      } else {
        await fileService.download(row.documentContratId);
      }
    }
    for (let i = 0; i < row.proposalDocuments.length; i++) {
      const document = row.proposalDocuments[i];
      
      if (document.isFileToChangeStatusAprobation) {
        if (document.document.contentType == "application/octet-stream") {
          await fileService.downloadOctetFile(
            document.document.id,
            document.document.originalName
          );
        } else {
          await fileService.download(document.documentId);
        } 
      }
    }
  }
}
